<div class="migration-banner" role="status">
    {{ 'LABELS.MIGRATION_BANNER' | translate:{date: shutdownDate} }}
</div>
